import { Box } from "@outschool/backpack";
import { useLinkComponent } from "@outschool/ui-utils";
import React from "react";

import CategoryNavbar from "./CategoryNavbar";
import HeaderLogo from "./HeaderLogo";
import HeaderNavItem from "./HeaderNavItem";

export default function StandardHeaderLeft({
  rootPath,
  showCategoriesNavbar,
  forceLargeLogo,
  categoryNavbarUseSearchLinks = false,
}: {
  rootPath: string;
  showCategoriesNavbar?: boolean;
  forceLargeLogo?: boolean;
  categoryNavbarUseSearchLinks?: boolean;
}) {
  const Link = useLinkComponent();
  return (
    <Box
      component={"section"}
      sx={{
        display: "flex",
        gap: "1em",
      }}
    >
      <HeaderNavItem
        sx={{
          paddingX: 0,
          display: "flex",
        }}
      >
        <Link
          to={rootPath}
          trackingName="nav_logo"
          reloadDocument
          style={{ display: "flex" }}
          aria-label="homepage button"
        >
          <HeaderLogo isWhiteText={false} forceLargeLogo={forceLargeLogo} />
        </Link>
      </HeaderNavItem>
      {showCategoriesNavbar && (
        <CategoryNavbar
          useButton
          useSearchLinks={categoryNavbarUseSearchLinks}
        />
      )}
    </Box>
  );
}
